module.exports = __webpack_public_path__ + "media/images/games/rocket-league/square-8ec6d8f318d35187a9e2dd31b18dee36.jpg";